import {Grid} from "@mui/material"
import React, {useEffect, useState} from "react"
import AlertMessage from "../../components/alert-message"
import DocumentosTableComponent from "../../components/documentos-table-component"
import PropTypes from 'prop-types'
import {onlyNumberRegex} from "../../utils/strings"
import {DOCUMENTOS_BUCKET} from "../../settings"

const OutroDocumentos = ({empresa}) => {
    const [keyDocument, setKeyDocument] = useState(Math.random() * 10)
    const [cpfCnpj, setCpfCnpj] = useState(null)
    const [cpfCnpjValid, setCpfCnpjValid] = useState(false)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: "info"
    })

    useEffect(() => {
        if(empresa == null) return

        const {CPFCNPJ} = empresa
        if(CPFCNPJ !== null) {
            setCpfCnpj(onlyNumberRegex(CPFCNPJ))
            setCpfCnpjValid(true)
            setKeyDocument(Math.random() * 10)
        }
    }, [empresa])

    const closeAlert = () => {
        setAlertMessageState({...alertMessageState, open: false})
    }

    const openAlert = (type, message) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    return <>
        <AlertMessage open={alertMessageState.open}
                      message={alertMessageState.message}
                      type={alertMessageState.type}
                      close={closeAlert}/>
        <Grid
            container
            direction="row"
            alignContent="flex-start"
            justifyContent="flex-start"
            spacing={0}
            sx={{
                padding: 2,
                // height: "100%", // altura de 100% da Box
            }}>
            <Grid item xs={12} sm={12} md={12} xl={12} sx={{height: "100%"}}>
                <DocumentosTableComponent
                    key={keyDocument}
                    enableUpload={cpfCnpjValid}
                    diretorio={`${DOCUMENTOS_BUCKET}`}
                    pasta={`empresa/${cpfCnpj}`} callbackAlert={openAlert}/>
            </Grid>
        </Grid>
    </>
}

OutroDocumentos.propTypes = {
    empresa: PropTypes.object,
}

export default OutroDocumentos